import React from 'react'
import SALink from 'components/SALink'
import FollowConnect from 'containers/Follow'
import PageConnect from 'containers/Page'
import { ArtistData } from '../types'
import { setDataLayer } from '../helpers'
import {
  Wrapper,
  ArtistArtworkWrapper,
  ArtistArtworkItem,
  Avatar,
  FollowButton,
  ArtistCountry,
  ArtistName,
  GenericFlexWrapper,
  ViewArtworks,
  ArtworkWrapper,
  Artwork,
  ArtistSection,
  ArtistInfoSection,
} from './Styles'
import { capitalizeString } from 'lib/helpers'

type Props = {
  page: Record<string, any>
  artistData: Array<ArtistData>
  following: Array<number>
  followUser: (...args: Array<any>) => any
  userID: number
}

const TrendingArtists = (props: Props) => {
  const {
    page: { data: artistData },
    following,
    followUser,
    userID,
  } = props
  return (
    <Wrapper>
      <h1 className='defaultTypographyH2'>Trending Artists</h1>
      <p className='defaultTypographyMedium' data-type='sub-text'>
        New artists from around the world join Saatchi Art every day. Our Trending Artists series
        highlights these emerging talents, who have recently been discovered by our collectors.
      </p>
      <p className='defaultTypographyMedium' data-type='sub-text'>
        Visit every week to find new works to fall in love with, and subscribe to Saatchi Art emails
        for special access to exclusive curated collections.
      </p>
      {(Object.keys(artistData) || []).slice(0, 10).map((item, key) => {
        const {
          artwork_info: artworkInfo,
          artist_name: artistName,
          artist_country: artistCountry,
          artist_id: artistId,
          artist_all_artworks_link: allArtworks,
          artist_profile_image_url: avatarUrl,
          artist_profile_link: artistProfile,
        } = artistData[item]
        const capitalizedArtistName = capitalizeString(artistName)
        const isFollowed = following.includes(artistId)

        return (
          <ArtistArtworkWrapper key={key}>
            <ArtistArtworkItem>
              <ArtistSection centerBoth>
                <SALink
                  href={artistProfile}
                  onClick={() => {
                    setDataLayer('profile', {
                      artistName,
                      artistId,
                    })
                  }}
                >
                  <Avatar
                    alt={capitalizedArtistName}
                    src={
                      avatarUrl ||
                      'https://d3t95n9c6zzriw.cloudfront.net/common/profile/avatar_small_square.jpg'
                    }
                  />
                </SALink>
                <ArtistInfoSection>
                  <ArtistName>
                    <SALink
                      href={artistProfile}
                      onClick={() => {
                        setDataLayer('profile', {
                          artistName,
                          artistId,
                        })
                      }}
                    >
                      <h5 className='defaultTypographyH5'>{capitalizedArtistName}</h5>
                    </SALink>
                  </ArtistName>
                  <ArtistCountry>
                    <p className='defaultTypographyXSmall'>{artistCountry}</p>
                  </ArtistCountry>
                  <GenericFlexWrapper mt='16px'>
                    <FollowButton
                      p={3}
                      href='#'
                      rel='nofollow'
                      following={!!isFollowed}
                      onClick={(e) => {
                        e.preventDefault()
                        followUser({
                          userID,
                          targetUserId: artistId,
                          following: !isFollowed,
                        })
                      }}
                      title={`Follow ${capitalizedArtistName}`}
                    >
                      <img
                        src={`https://d3t95n9c6zzriw.cloudfront.net/art-detail/artist-section/${
                          isFollowed ? 'checkmark' : 'plus'
                        }-white.svg`}
                        alt={`follow user  - ${capitalizedArtistName}`}
                      />
                      <p className='defaultTypographyCtaMedium'>Follow</p>
                    </FollowButton>
                    <ViewArtworks>
                      <SALink
                        onClick={() => {
                          setDataLayer('portfolio', {
                            artistName,
                            artistId,
                          })
                        }}
                        href={allArtworks}
                      >
                        <p className='defaultTypographyCtaMedium' data-type='view-artworks'>
                          View Artworks
                        </p>
                      </SALink>
                    </ViewArtworks>
                  </GenericFlexWrapper>
                </ArtistInfoSection>
              </ArtistSection>
              <ArtworkWrapper>
                {artworkInfo
                  .sort((a, b) => {
                    if (a.artwork_display_sequence < b.artwork_display_sequence) return -1
                    if (a.artwork_display_sequence > b.artwork_display_sequence) return 1
                    return 0
                  })
                  .map((artwork, key2) => {
                    const {
                      artwork_name: artworkName,
                      artwork_link: artworkLink,
                      artwork_image: imageUrl,
                      legacy_art_id: legacyArtId,
                    } = artwork

                    if (!imageUrl) {
                      return false
                    }

                    return (
                      <SALink
                        href={artworkLink}
                        alt={artworkName}
                        key={key2}
                        onClick={() => {
                          setDataLayer('artwork', {
                            'artwork title': artworkName,
                            'artwork id': legacyArtId,
                          })
                        }}
                      >
                        <Artwork alt={artworkName} src={imageUrl} />
                      </SALink>
                    )
                  })}
              </ArtworkWrapper>
            </ArtistArtworkItem>
          </ArtistArtworkWrapper>
        )
      })}
    </Wrapper>
  )
}

export default PageConnect(FollowConnect(TrendingArtists))
